export const ConnectorsSection: React.FC = () => {
  const connectorChips = [
    "Autodesk Construction Cloud",
    "BIM 360",
    "BIM",
    "SharePoint",
    "Teams",
    "Box",
    "OneDrive",
    "Dropbox",
    "Zendesk",
    "ERP / CSV Exports"
  ];

  return (
    <section
      id="connectors"
      className="connectors-section section-spacing bg-white relative overflow-hidden"
    >
      {/* CAD/Blueprint background - Unsplash free license */}
      <div className="absolute right-0 top-0 w-1/3 h-full opacity-5 pointer-events-none hidden xl:block">
        <img
          src="https://images.unsplash.com/photo-1590579491624-f98f36d4c763?auto=format&fit=crop&w=800&q=80"
          alt="Technical drawings"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container mx-auto relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
            Connect your stack. Keep your tools.
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            ARK eliminates silos by sitting above your ecosystem, not replacing it.
          </p>
        </div>

        {/* CAD/Blueprint visual banner */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-lg border border-slate-200">
          <img
            src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80"
            alt="Architectural blueprints and CAD drawings"
            className="w-full h-48 object-cover"
          />
        </div>

        {/* Connector chips */}
        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-bold text-slate-900 mb-6 text-center">Supported Sources</h3>
            <div className="flex flex-wrap justify-center gap-3">
              {connectorChips.map((chip) => (
                <span
                  key={chip}
                  className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-4 py-2 text-sm font-medium"
                >
                  {chip}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Outcome statement */}
        <div className="text-center mt-12">
          <p className="text-xl font-semibold text-slate-900">
            One search surface. One evidence-backed answer. One path to action.
          </p>
        </div>
      </div>
    </section>
  );
};
